import {ICONS} from './Icons';

export let B2CMenus = [
  {
    id: 1,
    title: 'Get Started',
    icon: ICONS.home_Icon,
    sub_menus: [],
    isShow: true,
    href: '/',
    key_name: 'get_started',
  },
  {
    id: 2,
    title: 'Orders',
    icon: ICONS.orderIcon,
    sub_menus: [],
    isShow: true,
    href: '/orders',
    key_name: 'orders',
  },
  {
    id: 3.5,
    title: 'Commissions',
    icon: ICONS.commissionsIcon,
    sub_menus: [],
    isShow: true,
    href: '/commission',
    key_name: 'commissions',
  },

  {
    id: 4,
    title: 'Listings',
    icon: ICONS.listing_Icon,
    sub_menus: [
      {
        id: 1,
        title: 'Listings',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: '/listings',
        key_name: 'listings',
      },
      {
        id: 2,
        title: 'Categories',
        icon: ICONS.mobileIcon,
        isShow: true,
        href: '/listing-category',
        key_name: 'listing_categories',
      },
      {
        id: 3,
        title: 'Custom Attributes',
        icon: ICONS.seoIcon,
        isShow: true,
        href: '/listing-attributes',
        key_name: 'custom_attributes',
      },
      {
        id: 4,
        title: 'Variant Types',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: '/listing-variants',
        key_name: 'variant_types',
      },
      {
        id: 5,
        title: 'Additional Features',
        icon: ICONS.nativeintegrationIcon,
        isShow: true,
        href: '/listing-configs',
        key_name: 'additional_features',
      },
      {
        id: 6,
        title: 'Reported Listings',
        icon: ICONS.reportedIcon,
        sub_menus: [],
        isShow: true,
        href: '/reported-listings',
        key_name: 'reported_listings',
      },
    ],
    isShow: true,
    key_name: 'listing_section',
  },
  {
    id: 5,
    title: 'Users',
    icon: ICONS.usersIcon,
    sub_menus: [
      {
        id: 1,
        title: 'Users',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: '/users',
        key_name: 'users',
      },
      {
        id: 2,
        title: 'User Attributes',
        icon: ICONS.mobileIcon,
        isShow: true,
        href: '/user-attributes',
        key_name: 'user_attributes',
      },
      {
        id: 3,
        title: 'Reviews & Ratings',
        icon: ICONS.reviewIcon,
        sub_menus: [],
        isShow: true,
        href: '/review-ratings',
        key_name: 'reviews_ratings',
      },
    ],
    isShow: true,
    key_name: 'user_section',
  },
  {
    id: 6,
    title: 'Report',
    icon: ICONS.reportIcon,
    sub_menus: [],
    isShow: true,
    href: '/reports',
    key_name: 'report_section',
  },
  {
    id: 6.2,
    title: 'Maps',
    icon: ICONS.auditIcon,
    sub_menus: [],
    isShow: true,
    href: '/maps',
    key_name: 'maps',
  },
  {
    id: 7,
    title: 'Promotions',
    icon: ICONS.adBanner_Icon,
    sub_menus: [
      {
        id: 0,
        title: 'Collections',
        icon: ICONS.collectionsIcon,
        isShow: true,
        href: '/collections',
        key_name: 'collections',
      },
      {
        id: 1,
        title: 'Promotion / Ads',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: '/promotions',
        key_name: 'promotions',
      },
      {
        id: 2,
        title: 'Coupons',
        icon: ICONS.mobileIcon,
        isShow: true,
        href: '/coupon',
        key_name: 'coupons',
      },
    ],
    isShow: true,
    key_name: 'marketing_section',
  },
  {
    id: 8,
    title: 'Finance',
    icon: ICONS.currencyIcon,
    sub_menus: [
      {
        id: 1,
        title: 'Transactions',
        icon: ICONS.transactionIcon,
        isShow: true,
        href: '/transaction',
        key_name: 'transactions',
      },
    ],
    isShow: true,
    key_name: 'finance_section',
  },
  {
    id: 10,
    title: 'Media',
    icon: ICONS.mediaIcon,
    sub_menus: [],
    isShow: true,
    href: '/media',
    key_name: 'media',
  },
  {
    id: 16,
    title: 'Communication',
    icon: ICONS.communicationIcon,
    sub_menus: [],
    isShow: true,
    href: '/communication-2',
    key_name: 'communication',
  },
  {
    id: 13,
    title: 'Channels',
    type: 'menu_group',
    sub_menus: [],
    isShow: true,
    key_name: 'channels_group',
  },
  {
    id: 11,
    title: 'Web',
    icon: ICONS.webIcon,
    sub_menus: [
      {
        id: 1,
        title: 'Website Editor',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: 'https://tradly.app/editor',
        isOpenNewTab: true,
        key_name: 'website_editor',
      },
      {
        id: 2,
        title: 'Change Templates',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: 'https://tradly.app/workspace/templates',
        isOpenNewTab: true,
        key_name: 'change_templates',
      },
      {
        id: 4,
        title: 'Pages',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: '/cms/p',
        key_name: 'pages',
      },
      {
        id: 5,
        title: 'Blog',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: '/cms/blog',
        key_name: 'blog',
      },
      {
        id: 6,
        title: 'Customise texts',
        icon: ICONS.appTranslateIcon,
        isShow: true,
        href: '/strings-customisation',
        key_name: 'customise_texts',
      },
      {
        id: 7,
        title: 'Add Integrations',
        icon: ICONS.mobileIcon,
        isShow: true,
        href: 'https://tradly.app/workspace/integrations',
        isOpenNewTab: true,
        key_name: 'add_integrations',
      },
      {
        id: 8,
        title: 'Domain',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: 'https://tradly.app/workspace/domain',
        isOpenNewTab: true,
        key_name: 'domain',
      },
    ],
    isShow: true,
    key_name: 'web_section',
  },
  {
    id: 12,
    title: 'App',
    icon: ICONS.appIcon,
    sub_menus: [
      {
        id: 1,
        title: 'Buy App Templates',
        icon: ICONS.iconGlobal,
        isShow: true,
        href: 'https://tradly.app/workspace/templates',
        isOpenNewTab: true,
        key_name: 'buy_app_templates',
      },
      {
        id: 2,
        title: 'Customisation',
        icon: ICONS.mobileIcon,
        isShow: true,
        href: '/app-customization',
        key_name: 'customisation',
      },
      {
        id: 3,
        title: 'Integrations',
        icon: ICONS.nativeintegrationIcon,
        isShow: true,
        href: '/app-integration',
        key_name: 'app_integrations',
      },
      {
        id: 4,
        title: 'Customise texts',
        icon: ICONS.appTranslateIcon,
        isShow: true,
        href: '/strings-customisation',
        key_name: 'customise_app_texts',
      },
    ],
    isShow: true,
    key_name: 'app_section',
  },
  {
    id: 14,
    title: 'Agents',
    icon: ICONS.aiStudioIcon,
    sub_menus: [],
    isShow: true,
    href: 'https://aistudio.tradly.app/inbox',
    iframe_url: 'https://aistudio.tradly.app/inbox',
    iframe_height: '100%',
    is_dynamic_side_menu: true,
    iframe_sidebar_max_width: '1000px',
    is_open_via_iframe_sidepan: true,
    isOpenNewTab: true,
    key_name: 'agents_section',
  },
  {
    id: 19,
    title: 'Vibe Coding',
    icon: ICONS.aiStudioIcon,
    sub_menus: [],
    isShow: true,
    href: 'https://vibe.tradly.app',
    iframe_url: 'https://vibe.tradly.app',
    iframe_height: '100%',
    is_dynamic_side_menu: true,
    iframe_sidebar_max_width: '1000px',
    is_open_via_iframe_sidepan: true,
    isOpenNewTab: true,
    is_channel: true,
    key_name: 'vibe_coding_section',
  },
  {
    id: 20,
    title: 'Apps',
    type: 'menu_group',
    sub_menus: [],
    isShow: true,
    key_name: 'apps_group',
  },
  {
    id: 2.1,
    title: 'Bookings Schedule',
    icon: ICONS.calendarIcon,
    sub_menus: [],
    isShow: true,
    href: '/schedule',
    opt_in: true,
    key_name: 'schedule',
  },
  {
    id: 6.1,
    title: 'Auth',
    icon: ICONS.auditIcon,
    sub_menus: [],
    isShow: true,
    href: '/platform-health',
    opt_in: true,
    key_name: 'platform_health',
  },
  {
    id: 24,
    title: 'MCP',
    icon: ICONS.aiStudioIcon,
    sub_menus: [],
    isShow: true,
    href: '/mcp-connections',
    is_channel: true,
    key_name: 'mcp_section',
  },
  {
    id: 9,
    title: 'Marketing',
    icon: 'https://media.tradly.app/images/marketplace/52892/ma(1)-TcjqA2Fw.webp',
    sub_menus: [],
    isShow: true,
    href: 'https://marketing.tradly.app/dashboard',
    is_linkable: true,
    iframe_url: 'https://marketing.tradly.app/dashboard',
    iframe_height: '100%',
    is_dynamic_side_menu: true,
    iframe_sidebar_max_width: '1000px',
    is_open_via_iframe_sidepan: true,
    is_channel: true,
    key_name: 'workflow',
  },
  {
    id: 21,
    title: 'Intelligence',
    icon: ICONS.aiStudioIcon,
    sub_menus: [],
    isShow: true,
    href: 'https://analytics.tradly.app',
    iframe_url: 'https://analytics.tradly.app',
    iframe_height: '100%',
    is_dynamic_side_menu: true,
    iframe_sidebar_max_width: '1200px',
    is_open_via_iframe_sidepan: true,
    isOpenNewTab: true,
    is_channel: true,
    key_name: 'intelligence_section',
  },
  {
    id: 26,
    title: 'Tradly Attribution',
    icon: ICONS.revenue_Icon,
    sub_menus: [],
    isShow: true,
    href: 'https://attribution.tradly.app',
    iframe_url: 'https://attribution.tradly.app',
    iframe_height: '100%',
    is_dynamic_side_menu: true,
    iframe_sidebar_max_width: '1200px',
    is_open_via_iframe_sidepan: true,
    isOpenNewTab: true,
    opt_in: true,
    key_name: 'tradly_attribution',
  },
  {
    id: 27,
    title: 'Social Connect',
    icon: ICONS.communicationIcon,
    sub_menus: [],
    isShow: true,
    href: '/social',
    opt_in: true,
    key_name: 'social_connect',
  },
  {
    id: 23,
    title: 'Subscription',
    icon: ICONS.aiStudioIcon,
    sub_menus: [],
    isShow: true,
    href: '/subscription',
    is_channel: true,
    key_name: 'subscription_section',
  },
  {
    id: 30,
    title: 'People',
    sub_menus: [],
    isShow: true,
    href: '/people',
    opt_in: true,
    key_name: 'people_app',
  },
  {
    id: 31,
    title: 'Workforce',
    sub_menus: [],
    isShow: true,
    href: '/workforce',
    opt_in: true,
    key_name: 'workforce_app',
  },
  {
    id: 32,
    title: 'Payroll',
    sub_menus: [],
    isShow: true,
    href: '/payroll',
    opt_in: true,
    key_name: 'payroll_app',
  },
  {
    id: 33,
    title: 'Expenses',
    sub_menus: [],
    isShow: true,
    href: '/expenses',
    opt_in: true,
    key_name: 'expenses_app',
  },
  {
    id: 34,
    title: 'Recurring Payments',
    sub_menus: [],
    isShow: true,
    href: '/recurring-payments',
    opt_in: true,
    key_name: 'recurring_payments_app',
  },

  //   {id: 16, title: 'More', icon: moreIcon, sub_menus: [], isShow: true},
];
